import { getVirtualKeyboardHeight } from './getVirtualKeyboardHeight';

/**
 * Checks whether the virtual keyboard is currently visible.
 *
 * @returns `true` if the virtual keyboard is visible, otherwise `false`.
 */
export function hasVisibleVirtualKeyboard(): boolean {
  // Use a small threshold to avoid false positives due to minor
  // viewport changes:
  return getVirtualKeyboardHeight() > 2;
}
